export default __webpack_public_path__ + "static/media/logo.e4b4f9cb.png";